module.exports = __webpack_public_path__ + "img/sidebar_ecl_202627.792feadc.png";